import React, { useEffect } from "react";

const Scheduler = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://embed.scheduleengine.net/schedule-engine-v3.js";
    script.defer = true;
    script.id = "se-widget-embed";
    script.setAttribute("data-api-key", "cl7eug488000008pu2dckbfiw");

    script.onload = () => {
      console.log("ScheduleEngine script loaded successfully");
    };

    script.onerror = (error) => {
      console.error("Error loading ScheduleEngine script:", error);
    };

    document.body.appendChild(script);
  }, []);

  const handleClick = () => {
    if (window.ScheduleEngine) {
      window.ScheduleEngine.show();
    } else {
      console.error("Scheduler script not loaded yet");
    }
  };

  return (
    <a 
        className="button--secondary flex justify-center items-center w-full font-bold text-[22px] uppercase px-8 py-3 laptop:px-12 laptop:inline-block laptop:w-auto laptop:rounded-lg"
        type="button"
        onClick={handleClick}
    >
      Book Now!
    </a>
  );
};

export default Scheduler;
